import { Currency } from '@/_models/Currency';
import { eCommerceTheme, Product, Settings } from '@/_models/eCommerce/Product';
import { TourMode } from '@/_models/Tour';

export enum EBottomBarActiveItem {
  cart = 'quickCart',
  favourite = 'favorites',
  nearestProducts = 'itemNearMe',
  reels = 'reel',
}

export type TProductListItem = {
  id: number;
  price: number;
  comparePrice: number;
  title: string;
  previewImage: {
    type: string;
    src: string;
  };
};

export interface IBottomBar {
  isFull: boolean;
  showPanorama: boolean;
  panoramaOn: boolean;
  currentFloor: number;
  tourPlaying: boolean;
  activeReel: EBottomBarActiveItem;
  isOpenReel: boolean;
  videoPlaying: boolean;
  minimapVisible: boolean;
  theme: eCommerceTheme;
  tourMode: TourMode;
  nearestProducts: any;
  favoriteProducts: any;
  favoriteProductsIds: any;
  cartProducts: any;
  tour: any;
  activeSweepGroup: any;
  mpFloors: any;
  reel: any;
  reelStep: any;
  moveToStep: any;
  isOpticalCenter: boolean;
  settings: Settings;

  translation: Record<string, string>;
  currency: Currency;
  currentSweep: any;

  onChangeFavourite: (p: Product, isMenu?: boolean) => void;
  openProduct: (p: Product) => void;
  toggleExternalPopup: (url: string) => void;
  changeFull: () => void;
  openVR: () => void;
  changeViewMode: (m: TourMode) => void;
  showPanoramaClick: () => void;
  changeFloor: (index: number, _all?: boolean) => void;
  getSetting: (setting: string) => Promise<any>;
  playTour: () => void;
  loadModel: () => void;
  openCart: () => void;
  openContactMe: () => void;
  onStopVideo: () => void;
  showMinimapClick: () => void;
  handleMeasureClick: () => void;
  handleNearProductStatus: (state: boolean) => void;
  getFavoriteProductsFromApi: () => Promise<any>;
  handleProductIdForPopup: (state: boolean, id: number) => void;
}
